import noteService from "../../api/noteService";

export const getTagList = () => {
  return async (dispatch) => {
    let response = await noteService.getTagList();
    if (!response.data.error) {
      dispatch({
        type: "FETCH_TAG_LIST",
        payload: response.data,
      });
    }
  };
};

export const filterNotes = (body) => {
  return async (dispatch) => {
    let response = await noteService.filterNotes(body);
    if (!response.data.error) {
      dispatch({
        type: "FILTER_NOTES",
        payload: response.data,
      });
    }
  };
};

export const handleNewNote = (isOpen) => {
  return async (dispatch) => {
    dispatch({
      type: "HANDLE_NEW_NOTE",
      payload: isOpen,
    });
  };
};

export const handleNewConferenceNote = (isOpen) => {
  return async (dispatch) => {
    dispatch({
      type: "HANDLE_NEW_CONFERENCE_NOTE",
      payload: isOpen,
    });
  };
};

export const handleIsEditing = (isEditing) => {
  return async (dispatch) => {
    dispatch({
      type: "HANDLE_IS_EDITING",
      payload: isEditing,
    });
  };
};

export const createNote = (note) => {
  return async (dispatch) => {
    let response = await noteService.createNote(note);
    if (!response.data.error) {
      dispatch({
        type: "CREATE_NOTE",
        payload: response.data,
      });
    }
  };
};

export const editNote = (note) => {
  return async (dispatch) => {
    let response = await noteService.editNote(note);
    if (!response.data.error) {
      dispatch({
        type: "EDIT_NOTE",
        payload: response.data,
      });
    }
  };
};

export const minimizeNote = (title) => {
  return async (dispatch) => {
    dispatch({
      type: "MINIMIZED_NOTE",
      payload: title,
    });
  };
};

export const deleteNote = (ids, deleteFiles) => {
  let body = { ids, deleteFiles };
  return async (dispatch) => {
    let response = await noteService.deleteAllNotes(body);
    if (!response.data.error) {
      dispatch({
        type: "DELETE_NOTE",
        payload: ids,
      });
    }
  };
};
export const fetchLastNoteList = (limit = 5, offset = 0) => {
  return async (dispatch) => {
    let response = await noteService.getLastNoteList(limit, offset);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_LAST_NOTE_LIST",
        payload: response.data,
      });
    }
  };
};
